



import React, { useState, useMemo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  CircularProgress,
  Tooltip,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Divider,
  TextField,
  Typography,
  Chip
} from '@mui/material';
import LocationCityRoundedIcon from '@mui/icons-material/LocationCityRounded';

import { useSelector } from 'react-redux';

import { useFetch } from '../../../hooks/useFetch';

import { PanelsProfileInfoRow } from './PanelsProfileInfoRow/PanelsProfileInfoRow';

export const PanelsProfileInfoTable = () => {
  const activeContract = useSelector((state) => state.contracts.activeContract);


  const { data, loading } = useFetch(`contracts/failandalarms`);


  const [sortBy, setSortBy] = useState('alphabetical');
  const [searchQuery, setSearchQuery] = useState('');


  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };


  const dataToIdDeviceCounts = (data || []).map(({ id, device_counts }) => ({ id, device_counts }));
  //returns the total number of devices of each type
  const totalDeviceCounts = (data) => {
    if (!data) return [];
    let panelsCount = 0
    let nodesCount = 0
    let gatewaysCount = 0

    data?.forEach(({ device_counts }) => {
      panelsCount += device_counts[0] || 0;
      nodesCount += device_counts[1] || 0;
      gatewaysCount += device_counts[2] || 0;
    });

    return ([panelsCount, nodesCount, gatewaysCount])
  };
  //Datos para visualizacion de numero de dispositivos por version
  //Para CMs
  const panelsStateData = useSelector((state) => state.panels.panels);
  const panelsFirmwareData = (panelsStateData || []).map(({ id, contract_id, firmware_version }) => ({ id, contract_id, firmware_version }));
  //Para nodos
  const nodesStateData = useSelector((state) => state.nodes.nodes);
  const nodesFirmwareData = (nodesStateData || []).map(({ id, contract_id, firmware_version }) => ({ id, contract_id, firmware_version }));
  const countDevicesPerFirmware = (data) => {
    if (!data) return [];
    /***
     * result = [
     * {firmware, nElements, [ids]}
     * ]
     */
    const result = []
    const firmwareVersions = []
    data?.forEach(({ id, contract_id, firmware_version }) => {
      if (firmwareVersions.includes(firmware_version)) {
        //si ya estaba entonces se añaden o modifican datos necesarios
        let firmwareRowToUpdate = result.find(row => row.firmware_version === firmware_version);
        if (firmwareRowToUpdate) {
          firmwareRowToUpdate.devicesIds.push(id);
          firmwareRowToUpdate.nDevices = firmwareRowToUpdate.devicesIds.length;
        }
      } else {
        //Si es la primera vez que sale entonces se le añade
        firmwareVersions.push(firmware_version);
        result.push({
          firmware_version,
          nDevices: 1,
          devicesIds: [id]
        })
      }

    });
    return result
  };




  const filteredContracts = useMemo(() => {
    if (!data) return [];
    return data.filter((contract) =>
      contract.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [data, searchQuery]);
  const sortedContracts = useMemo(() => {
    if (!filteredContracts) return [];

    const contractsCopy = [...filteredContracts];

    if (sortBy === 'alphabetical') {
      return contractsCopy.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortBy === 'nodes') {
      return contractsCopy.sort((a, b) => b.fails_nodes.fails24.length - a.fails_nodes.fails24.length);
    } else if (sortBy === 'panels') {
      return contractsCopy.sort((a, b) => b.fails_cm.fails24.length - a.fails_cm.fails24.length);
    } else if (sortBy === 'gateways') {
      return contractsCopy.sort((a, b) => b.fails_gateways.fails24.length - a.fails_gateways.fails24.length);
    }

    return contractsCopy;
  }, [filteredContracts, sortBy]);

  return (
    <>
      {(loading || !activeContract) ? (
        <CircularProgress color="primary" />
      ) : (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>

            <TextField
              label="Buscar contrato"
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ marginRight: '16px' }}
            />
            <FormControl variant="outlined" style={{ width: '160px', height: '40px' }}>
              <InputLabel id="sort-by-label">Ordenar por</InputLabel>
              <Select
                labelId="sort-by-label"
                value={sortBy}
                onChange={handleSortChange}
                label="Ordenar por"
              >
                <MenuItem value="panels">Centros de mando</MenuItem>
                <MenuItem value="nodes">Nodos</MenuItem>
                <MenuItem value="gateways">Gateways</MenuItem>
                <MenuItem value="alphabetical">Alfabéticamente</MenuItem>
              </Select>
            </FormControl>
          </div>

          <Divider />

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>

                  <TableCell style={{ textAlign: 'left', fontWeight: 'bold', fontSize: '1.05rem', borderRight: '1px solid black' }}>
                    <LocationCityRoundedIcon style={{ fontSize: '1.05rem', color: 'blue', marginRight: '0.5rem' }} />
                    Contrato
                  </TableCell>
                  <TableCell style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.05rem', borderRight: '1px solid black' }}>
                    <Typography> Tridonic </Typography>
                  </TableCell>
                  <TableCell style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.05rem', borderRight: '1px solid black' }}>
                    <Typography> Relé diferencial circutor </Typography>
                  </TableCell>

                  <TableCell style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.05rem', borderRight: '1px solid black' }}>
                    <Typography>
                      Salidas adicionales
                    </Typography>
                  </TableCell>
                  <TableCell style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.05rem', borderRight: '1px solid black' }}>
                    <Typography>
                      Mantenimiento
                    </Typography>
                  </TableCell>

                </TableRow>
              </TableHead>

              <TableBody>
                {Array.isArray(sortedContracts) && sortedContracts.length > 0 ? (
                  sortedContracts.map((contract) => (
                    <PanelsProfileInfoRow key={contract.id} contract={contract}
                      activeContractData={{ id: activeContract?.id, u6me2: activeContract?.u6me2, differentialCircutor: activeContract?.differential_circutor, maintenance: activeContract?.maintenance, additionalPanelOutputs: activeContract?.additional_panel_outputs }}
                      countPanelsPerFirmware={() => {
                        if (panelsStateData[0]?.contract_id == activeContract.id) {
                          return (countDevicesPerFirmware(panelsFirmwareData));
                        }
                        else {
                          return []
                        }

                      }}
                      countNodesPerFirmware={() => {

                        if (nodesStateData[0]?.contract_id == activeContract.id) {
                          return (countDevicesPerFirmware(nodesFirmwareData));
                        }
                        else {

                          return []
                        }

                      }}
                    />
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} style={{ textAlign: 'center' }}>
                      No se encontraron contratos
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div >
      )}
    </>
  );
};




